<p>Environment
  <select [(ngModel)]="env">
    <option>CD</option>
    <option>DEV</option>
    <option>QA</option>
    <option>PROD</option>
    <option>TRAINING</option>
    <option>RESTORE</option>
  </select>
  <input type="text" [(ngModel)]="application" />
  <button type="button" class="btn-sm btn btn-primary" (click)="refresh()">Refresh</button>
</p>

@if (applicationStatus) {
  <h2>{{applicationStatus.applicationId}}</h2>

  <h3>Versions</h3>
  <table class="table table-sm table-hover">
    <thead>
    <tr>
      <th>applicationVersion</th>
      <th>tenantGroupMatchCode</th>
      <th>tenantGroupOnline</th>
      <th>tenantStatus</th>
    </tr>
    </thead>
    <tbody>
      @for (applicationVersionStatus of applicationStatus.applicationVersionStatus; track applicationVersionStatus.applicationVersion) {
        <tr>
          <td>{{applicationVersionStatus.applicationVersion}} ({{format(applicationVersionStatus.applicationVersion)}})</td>
          <td>{{applicationVersionStatus.tenantGroupMatchCode}}</td>
          <td>{{applicationVersionStatus.tenantGroupOnline}}</td>
          <td>
            <ul>
              @for (tenantStatus of applicationVersionStatus.tenantStatus; track tenantStatus.tenantId) {
                <li>
                  tenantId: {{tenantStatus.tenantId}}
                  tenantOnline: {{tenantStatus.tenantOnline}}
                  legacyVersion: {{tenantStatus.legacyVersion}}
                  activationGroup: {{tenantStatus.activationGroup}}
                </li>
              }
            </ul>
          </td>
        </tr>
      }
    </tbody>
  </table>
}
